module.exports = __webpack_public_path__ + "static/img/1000000435_red.788db330.jpg";